
import axios from 'axios';
import BaseLoader from '@/components/BaseLoader.vue';
import LayoutCenter from '@/components/LayoutCenter.vue';
import { setMeta } from '@/store';
import { useForm } from '@/store/form';
import { defineComponent, ref } from 'vue';

export default defineComponent({
  components: {
    BaseLoader,
    LayoutCenter,
  },
  setup() {
    const submitting = ref(false);
    const submitted = ref<string | boolean>(false);

    const { firstName, lastName, email, valid, validate } = useForm();

    const postSubscription = async () => {
      try {
        const params = new URLSearchParams();
        params.append('email', email.value);
        params.append('firstname', firstName.value);
        params.append('lastname', lastName.value);
        await axios.post(process.env.VUE_APP_SUB_ENDPOINT, params);
        submitted.value = true;
      } catch (e) {
        submitted.value = false;
        valid.value = 'Something went wrong, please try again later.';
      } finally {
        submitting.value = false;
      }
    };

    const onSubmit = () => {
      valid.value = validate(true);
      if (valid.value === true) {
        submitting.value = true;
        postSubscription();
      }
    };
    setMeta({ title: 'Subscribe' });

    return {
      submitting,
      submitted,
      firstName,
      lastName,
      email,
      valid,
      onSubmit,
    };
  },
});
